// R3 D3类的spec
// 必须是系列产品（产品为数组）才可以使用这个函数！！！！！！sku级别上为单双品（单个产品，一个或者两个sku规格 => 不是指sn过站点规格）时千万不可以使用该函数！！
export const formatMultiSpecData = (catagory: any, arr: any) => {
    const flag = arr?.every((item: any) => item && item?.skuList && item?.skuList.length > 0);
    if (!flag) {
        return [];
    }

    const { specGroupList } = catagory[0] || [];
    const commonGroups: any = [];

    arr?.map((item: any, _: number) => {
        if (!item?.skuList || item?.skuList.length === 0) {
            return;
        }
        const skuItem = item?.skuList[0];
        const skuSpecObj = JSON.parse(typeof skuItem?.ownSpec === 'string' ? skuItem?.ownSpec : JSON.stringify(skuItem?.ownSpec) || '{}');
        // 三者共有的secGroups（至少有一个）
        specGroupList?.map((group: any) => {
            if (arr?.some((_: any) => skuSpecObj[group?.specGroupId]) && !commonGroups?.includes(group)) {
                commonGroups.push(group);
            }
        });

        // 三者至少有一个specParams
        commonGroups?.map((group: any) => {
            group.specParamList = group?.specParamList?.filter((param: any) => {
                const groupObjP = JSON.parse(
                    typeof skuSpecObj[group?.specGroupId] === 'string'
                        ? skuSpecObj[group?.specGroupId]
                        : JSON.stringify(skuSpecObj[group?.specGroupId]) || '{}',
                );
                if (groupObjP[param?.specParamId]) {
                    return param;
                }
            });
        });
    });

    return commonGroups;
};
